import axios from '../../api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getProductList = createAsyncThunk('productList', async () => {
  const response = await axios.get(
    `/products`
  );
  return response.data;
});
